/*
 * Module
 */

rs.module("development/codedemos/exampleflowwizard/namestep", [],

    function () {

        function initialize(jsSelectors) {

            var checkbox = $.js(jsSelectors.enableNext);
            checkbox.change(function () {
                console.log(checkbox.prop("checked"));
            });

            var name = $.js(jsSelectors.name);
            name.on("input", function () {
                console.log(name.val());
            });
        }

        // Exported public API
        var exports = {
            initialize: initialize
        };

        return exports;
    }
);